<template>
  <div>
    <input
      type="text"
      v-model="search"
      class="search"
      :placeholder="$t('floors.search')"
    />
    <transition-group name="staggered-fade" class="booth-wrap" tag="div">
      <div class="booth-item" v-for="item in filteredBooths" :key="item.loc_name">
        <!-- <div class="booth-logo-wrap">
					<img :src="'/api/booth/' + item.loc_name +'/logo?sid=' + sid()" />
				</div> -->
        <router-link :to="'/booth/' + item.loc_name" class="square-button">{{
          item.loc_fullname
        }}</router-link>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: "",
    };
  },
  computed: {
    filteredBooths() {
      return this.allbooths.filter((booth) =>
        booth.loc_fullname.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },
  props: {
    allbooths: Array,
  },
  methods: {
    sid() {
      return localStorage.getItem("sid");
    },
  },
};
</script>

<style lang="scss" scoped>
.booth-wrap {
  display: flex;
  flex-wrap: wrap;
  padding: 0 5%;
  box-sizing: border-box;
  margin-top: 50px;
  justify-content: center;
}
.booth-item {
  width: calc(33% - 20px);
  min-width: 270px;
  margin: 10px;
  padding: 7px;
  box-sizing: border-box;
  border: solid 1.5px #cfd8dc;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  transition: all 0.3s linear;
  border-radius: 5px;
}
.search {
  max-width: 300px;
  margin: 20px auto;
}
.square-button {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 68px;
  max-height: 68px;
  width: 100%;
  background: #fcd07a;
  flex-grow: 1;
  border-radius: 5px;
}
</style>
